import { palette } from '../../theme/palette';
import { Allergy } from '../types';

export const allergies: Allergy[] = [
  {
    text: 'Dairy',
    icon: ['fad', 'cow'],
    iconColor: palette.primary_700,
    backgroundColor: palette.primary_200,
  },
  {
    text: 'Eggs',
    icon: ['fad', 'egg'],
    iconColor: palette.yellow_700,
    backgroundColor: palette.yellow_200,
  },
  {
    text: 'Wheat',
    icon: ['fad', 'wheat'],
    iconColor: palette.success_500,
    backgroundColor: palette.success_200,
  },
  {
    text: 'Peanuts',
    icon: ['fad', 'peanuts'],
    iconColor: palette.orange_700,
    backgroundColor: palette.orange_200,
  },
  {
    text: 'Treenuts',
    icon: ['fad', 'acorn'],
    iconColor: palette.primary_700,
    backgroundColor: palette.primary_200,
  },
  {
    text: 'Shellfish',
    icon: ['fad', 'shrimp'],
    iconColor: palette.orange_700,
    backgroundColor: palette.orange_200,
  },
  {
    text: 'Soy',
    image: require('../assets/soy_icon.png'),
    iconColor: palette.success_500,
    backgroundColor: palette.success_200,
  },
  {
    text: 'Sesame',
    image: require('../assets/sesame_icon.png'),
    iconColor: palette.secondary_700,
    backgroundColor: palette.secondary_200,
  },
];
